module.exports = __webpack_public_path__ + "static/img/son4_active.efdc2e02.jpg";